<div class="beta">
    <h6>BETA - Pilotversion</h6>
    <h6>Empfehlung: Funktioniert am besten mit der neuesten/aktuellsten Version des Firefox oder des Chrome
        Browsers.</h6>
</div>

<div class="create-new-whiteboard">
    <button (click)="onClick()">Tafelbilder Erstellen <i class="fas fa-edit"></i></button>
</div>
<app-whiteboard-tip></app-whiteboard-tip>
<h3>Schritt-für-Schritt <br>Tafelbilder</h3>
<app-whiteboard-drawings-list [bookId]="applicationStateService.bookId"></app-whiteboard-drawings-list>

